import { useGT } from 'gt-react';
import { CheckCircleIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { useIsSavingApprovals } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

/**
 * Releases the lines in this cart. The cart toggle is the release selection,
 * so the label carries the count and the button is disabled at zero.
 */
export function ReleaseCartButton({
  creating,
  releaseCount,
  onCreate,
}: {
  creating: boolean;
  releaseCount: number;
  onCreate: () => void;
}) {
  const gt = useGT();
  const hasLines = releaseCount > 0;
  // An approval still saving would be missing from the release.
  const savingApprovals = useIsSavingApprovals();
  return (
    <Button
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        onCreate();
      }}
      disabled={creating || !hasLines || savingApprovals}
      title={
        hasLines
          ? gt('Release the approved lines in this cart as draft orders', {
              context: 'cart release button tooltip',
            })
          : gt('Approve lines to release them', {
              context: 'cart release button empty tooltip',
            })
      }
      className="h-6 shrink-0 bg-green-600 px-2 text-white hover:bg-green-700"
    >
      <CheckCircleIcon className="mr-1 h-3 w-3" />
      {gt('Release {count} approved', {
        context: 'cart release button',
        count: String(releaseCount),
      })}
    </Button>
  );
}
